import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import EmBreveCard from "@/components/EmBreveCard";

import { ferramenta } from "./ferramentas";
import { ROTA_FIDELIZE } from "./rotas";

// Página das formas de fidelizar que ainda estão por vir (pontuação, cartão, roleta).
export default function EmBrevePage({ id }) {
  const navigate = useNavigate();
  const f = ferramenta(id);
  if (!f) return null;
  return (
    <div className="p-4 sm:p-6" data-e2e={`fidelize-${id}`}>
      <div className="max-w-3xl mx-auto">
        <button type="button" onClick={() => navigate(ROTA_FIDELIZE)}
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-4">
          <ArrowLeft className="w-4 h-4" /> Fidelize seu cliente
        </button>
        <EmBreveCard icon={f.icone} titulo={f.titulo} descricao={f.resumo} itens={f.itens} />
      </div>
    </div>
  );
}
